import {
  SimpleChanges,
  EventEmitter,
  Component,
  OnInit,
  Output,
  Input,
} from '@angular/core';

import { PaymentStatusPreSubmit, PAYMENT_COMPS } from 'src/app/core';

import {
  PaymentTransportationMethod,
  PaymentStepperNewEvent,
  PaymentEntity,
  Voucher,
} from 'src/app/shared';

import { PaymentService } from '../../services';
import { Step } from '../../utilities';

@Component({
  selector: 'payment-final-factor',
  templateUrl: './final-factor.component.html',
  styleUrls: ['./final-factor.component.scss'],
})
export class FinalFactorComponent
  extends Step<PaymentStepperNewEvent>
  implements OnInit
{
  @Output('stepper') stepperEvent: EventEmitter<PaymentStepperNewEvent> =
    new EventEmitter();

  @Output('voucherChange') voucherSelect: EventEmitter<Voucher> =
    new EventEmitter();
  @Input('voucher') voucher!: Voucher;

  @Input('payment') payment!: PaymentEntity;
  @Input('activatedStep') activatedStep!: string;
  @Input() transportMethod!: PaymentTransportationMethod;

  // Getter & setters -------------------------->

  public get isActivated(): boolean {
    return this.activatedStep === this.name;
  }

  // Constructors ------------------------------>
  async ngOnInit(): Promise<void> {}

  async ngOnChanges(change: SimpleChanges) {
    if (change && 'payment' in change && change['payment'].currentValue) {
      this.payment = change['payment'].currentValue;
    }
  }

  constructor(private paymentService: PaymentService) {
    super(PAYMENT_COMPS.FINAL_FACTOR);
  }

  // Public methods ---------------------------->

  previous(): void {
    this.stepperEvent.next(this.getEvent('previous'));
  }

  next(): void {
    this.stepperEvent.next(this.getEvent('next'));
  }

  init(): void {
    this.stepperEvent.next(this.getEvent('init'));
  }

  public finalize(): void {
    this.stepperEvent.next(this.getEvent('finalize'));
  }

  public selectVoucher(voucher: Voucher) {
    this.voucherSelect.emit(voucher);
  }

  public get paymentStatus(): PaymentStatusPreSubmit {
    return {
      price: +this.totalPrice,
      selectedCount: this.selectedCount,
    };
  }

  public startPayment() {
    this.paymentService.startPaymentAndRedirect(this.payment.id);
  }

  // Private methods --------------------------->

  private get totalPrice(): number {
    return this?.payment?.amount! || 0;
  }

  private get selectedCount(): number {
    if (!this?.payment || !this?.payment?.orders) {
      return 0;
    }

    return this.payment?.orders?.length;
  }

  private getEvent(
    name: PaymentStepperNewEvent['name']
  ): PaymentStepperNewEvent {
    return this.generateEvent(name, this.name);
  }
}
